(function () {
  'use strict';

  var SELECTOR = '.instagram-premium';

  function init(el) {
    if (el._igRevealed) return;
    el._igRevealed = true;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.classList.add('is-revealed');
      return;
    }

    var reveals = el.querySelectorAll('[data-reveal]');
    if (reveals.length) {
      var rObs = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            entries[i].target.classList.add('is-revealed');
            rObs.unobserve(entries[i].target);
          }
        }
      }, { threshold: 0.15 });
      for (var j = 0; j < reveals.length; j++) rObs.observe(reveals[j]);
    }

    var obs = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          el.classList.add('is-revealed');
          obs.unobserve(el);
        }
      }
    }, { threshold: 0.1 });
    obs.observe(el);
  }

  function scan() {
    var els = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < els.length; i++) init(els[i]);
  }

  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector(SELECTOR);
      if (el) init(el);
    });
  }
})();
